export default __webpack_public_path__ + "static/media/chandan_a.8b795328.png";